module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_upward_shadow.acbb0be1.png";